import { render } from "./AlphabetFilter.vue?vue&type=template&id=e54c3892&scoped=true"
import script from "./AlphabetFilter.vue?vue&type=script&lang=js"
export * from "./AlphabetFilter.vue?vue&type=script&lang=js"

import "./AlphabetFilter.vue?vue&type=style&index=0&id=e54c3892&scoped=true&lang=css"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54c3892"]])

export default __exports__